<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 法律信息链接区 -->
      <div class="footer-links">
        <NuxtLink :to="localePath('/about')" class="footer-link">
          <Icon name="material-symbols:info" size="16" />
          {{ $t('footer.links.about') }}
        </NuxtLink>
        <span class="separator">|</span>
        <NuxtLink :to="localePath('/privacy')" class="footer-link">
          <Icon name="material-symbols:shield" size="16" />
          {{ $t('footer.links.privacy') }}
        </NuxtLink>
        <span class="separator">|</span>
        <NuxtLink :to="localePath('/blog')" class="footer-link">
          <Icon name="material-symbols:article-outline" size="16" />
          {{ $t('footer.links.blog') }}
        </NuxtLink>
        <span v-if="icpRecord" class="separator">|</span>
        <a
          v-if="icpRecord"
          :href="icpLink"
          class="footer-link"
          target="_blank"
          rel="noopener"
        >
          <Icon name="material-symbols:domain-verification" size="16" />
          {{ icpRecord }}
        </a>
        <span class="separator">|</span>
        <a
          :href="publicSecurityLink"
          class="footer-link"
          target="_blank"
          rel="noopener"
        >
          <Icon name="material-symbols:security" size="16" />
          {{ publicSecurityRecordText }}
        </a>
      </div>

      <!-- 版权声明区 -->
      <div class="footer-copyright">
        <p>{{ $t('footer.copyright', { year: currentYear }) }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import {
  ICP_RECORD_LINK,
  PUBLIC_SECURITY_RECORD_LINK,
  PUBLIC_SECURITY_RECORD_TEXT,
  getIcpRecordByHost
} from '~/utils/footerLegalLinks';
// @nuxt/icon 模块已自动提供 <Icon> 组件，无需手动导入

// 获取当前年份
const headers = process.server ? useRequestHeaders(['host']) : null;

const host = ref('');
if (process.server && headers?.host) {
  host.value = headers.host.split(':')[0];
}

if (process.client) {
  onMounted(() => {
    host.value = window.location.hostname;
  });
}

const icpLink = ICP_RECORD_LINK;
const icpRecord = computed(() => getIcpRecordByHost(host.value));
const publicSecurityLink = PUBLIC_SECURITY_RECORD_LINK;
const publicSecurityRecordText = PUBLIC_SECURITY_RECORD_TEXT;

const currentYear = new Date().getFullYear();
const localePath = useLocalePath();
</script>

<style scoped lang="scss">
.footer {
  background-color: $gray-100;
  border-top: 1px solid $gray-200;
  margin-top: auto; // 确保页脚始终在页面底部
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: $spacing-lg $spacing-md;
  text-align: center;
}

// 法律信息链接区样式
.footer-links {
  margin-bottom: $spacing-md;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: $spacing-sm;

  .footer-link {
    display: flex;
    align-items: center;
    gap: $spacing-xs;
    color: $gray-600;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.2s ease;

    &:hover {
      color: $primary-color;
      text-decoration: underline;
    }

    .iconify {
      flex-shrink: 0;
      color: $accent-color !important;
      filter: drop-shadow(0 1px 2px rgba($accent-color, 0.3));
    }
  }

  .separator {
    color: $gray-400;
    font-size: 14px;
    margin: 0 $spacing-xs;
  }
}

// 版权声明区样式
.footer-copyright {
  p {
    margin: 0;
    color: $gray-500;
    font-size: 12px;
    line-height: 1.4;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .footer-container {
    padding: $spacing-md $spacing-sm;
  }

  .footer-links {
    flex-direction: column;
    gap: $spacing-xs;

    .separator {
      display: none; // 移动端隐藏分隔符
    }
  }

  .footer-copyright {
    p {
      font-size: 11px;
    }
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: $spacing-sm;
  }

  .footer-links {
    .footer-link {
      font-size: 13px;
    }
  }
}
</style>
